import { HttpErrorResponse, HttpEvent, HttpEventType, HttpHeaders } from '@angular/common/http';
import { UPLOAD_CONS } from '@core/constants/UploadConstants';
import { delay, retryWhen, tap } from 'rxjs/operators';
import { SHARE_DC } from '../constants/ShareDCURLs';
import { UploadQueueImpl } from './UploadQueueImpl';
import { UploadUtility } from './UploadUtil';
declare var ProgressBar: any;

export class UploadLargeFile {

    protected http:any;
    protected router:any;
    protected universalService:any;
    static singleInstance:any;
    localStorageService:any;
    delay:any = 0;
    totalRemainingBytes:any = 0;
    largeUploadRateArray = []; // maintain large file uploadrate
    uploadUtil: UploadUtility;
    static uploadLargeFileRef : any;

    constructor(protected globalService){
        this.initializeProperties();
    }

    initializeProperties(){
        this.http = this.globalService.getHttpClientRef();
        this.router = this.globalService.getRouterRef();
        this.universalService = this.globalService.getUniversalServiceRef();
        this.localStorageService = this.globalService.getLocalStorageSvcRef();
        // this.universalService.MarkNewObjArray = [];
        this.uploadUtil = UploadUtility.getInstance(this.globalService);
        this.uploadUtil.uploadedObjectResponse = {};
        UploadLargeFile.uploadLargeFileRef = this;
    }

    public static getInstance(globalService):UploadLargeFile{
        if(this.singleInstance == null){
          this.singleInstance = new UploadLargeFile(globalService);
          return this.singleInstance;
        }else{
          return this.singleInstance;
        }
    }

    public async getChunkReadProgress(timeStamp,currentOffset, file, classRef,queueIndex,uploadQueue){
      let chunkReadRate =  classRef.getChunkReadBytesArraynRate(timeStamp,currentOffset, file, classRef,queueIndex,uploadQueue);
      if(chunkReadRate){ 
        if(UploadQueueImpl.timeLeftToFinishUpload == ""){
          classRef.timeRemaining =  classRef.uploadUtil.getRemainingLargeFileSizeRead(uploadQueue)/ (chunkReadRate*1000);
          classRef.getEstimatedReadTimeString(chunkReadRate) // In case of single large file upload, directly get estimated reading time;
        }
        else{
          classRef.getMultipleUploadTotalTime(chunkReadRate, true, file,uploadQueue) // In case of multiple file upload, check if any other upload started;
        }
      }  
    }

  
    public getChunkReadBytesArraynRate( timeStamp,currentOffset, file, classRef,queueIndex,uploadQueue){
      let chunkReadRate:number;
      uploadQueue[queueIndex].remainingLargeSizeRead = uploadQueue[queueIndex].largeSize - currentOffset;

      if(file.firstChunkReadTimeStamp == undefined) {
        file.firstChunkReadTimeStamp = timeStamp; 
        file.lastChunkReadTimeStamp = timeStamp;
        if(UploadQueueImpl.commonReadRate > 0)
          return UploadQueueImpl.commonReadRate;
        return;       
      }
      else if(((timeStamp- file.lastChunkReadTimeStamp> UPLOAD_CONS.CHUNK_READ_TIME_CAL_DELAY) ||
        !file.lastChunkReadTimeStamp) 
        && currentOffset> UPLOAD_CONS.SMALL_FILE_SIZE_LIMIT/2){
        const chunkReadTime = timeStamp - file.firstChunkReadTimeStamp;
        chunkReadRate = currentOffset/ chunkReadTime;
        file.remainingBytes = file.size - currentOffset;
        file.remainingLargeSizeRead =   file.size - currentOffset;
        file.timeToRead = (file.remainingBytes / (chunkReadRate));
        UploadQueueImpl.commonReadRate =  (UploadQueueImpl.commonReadRate+chunkReadRate)/2;
        file.lastChunkReadTimeStamp= timeStamp;
        return chunkReadRate
      }  
    }

    addFileToPrepList(obj,filesPreparinginFolder){
      filesPreparinginFolder.push(obj)
    }
    
    removeFileFromPrepList(fileObj,filesPreparinginFolder){
      let index = filesPreparinginFolder.findIndex((item)=> {
       return item.name == fileObj.name
      })
      filesPreparinginFolder.splice(index,1)
    }
    abortReadingOfAllFilesInFolder(filesPreparinginFolder){
      filesPreparinginFolder.forEach(file => {
        file.fileReader.abort();
      });
    }

    public async  startLargeFileReadAndUpload(file,queueIndex,isFolderFile,ffile,resolveFromQueue,filesPreparinginFolder,uploadQueue){
      await this.uploadUtil.getUploadUrlForMultiDc();
      file.waiting = false;
      file.isError = false;
      file.uploadDone = false;
      file.preparingUpload=true;
      file.uploadStarted = false;
      file.uploadDone = false;
      file.inProgress = true;

      let classRef = this;
      try {
        let hash;
        if(isFolderFile)
          this.addFileToPrepList(file,filesPreparinginFolder)

        if(file.hash == undefined || file.hash.length != 32){   
          file.hasher = this.uploadUtil.getIncrementalChecksumUtilInstance(UploadLargeFile.uploadLargeFileRef);
          hash = await file.hasher.getFileHash(file,queueIndex,uploadQueue,classRef.getChunkReadProgress);
        }else{
          hash = file.hash
        }
        if(hash){
          if(isFolderFile)
            this.removeFileFromPrepList(file,filesPreparinginFolder)
          file.hash = hash;
          if(file.unique == undefined){
            file.unique = new Date().getMilliseconds()+file.hash; 
        }
          file.preparingUpload = false;
          file.uploadStarted = true;
          await new Promise(async (resolve, reject) => {
            classRef.largeUploadRateArray = []; 
            classRef.totalRemainingBytes = this.uploadUtil.getRemainingBytes(uploadQueue,queueIndex) 
            const fileMetadata = this.uploadUtil.getfileMetaData(file)
            const httpOptions = { observe: 'events', reportProgress: true};
            let url = "";
            if(window.location.href.includes("sharedwithme")){
              url = SHARE_DC["DC_URLS"]["CHUNK_UPLOAD_INITIATE"];
            }else{
              url = UPLOAD_CONS.SERVICE_URL.CHUNK_UPLOAD_INITIATE;
            }
            if(file["tfKey"]){
              url = url + "?tfKey=" + file["tfKey"];
            }
            let initiateUploadHttpRequest =  classRef.http.post(url,fileMetadata,httpOptions);
        
            if(!window.location.href.includes('enterprise/userprofile') && !isFolderFile){
              classRef.uploadUtil.fileProgressUI(file);
            }
            if(!isFolderFile){
              file.subscriber = initiateUploadHttpRequest.pipe(
                retryWhen(errors => // Auto Retry Request  or Error Out, for conditions check 'ifRetryRequest' function
                      errors.pipe(
                          delay(UPLOAD_CONS.AUTORETRY_REQ_TIME_DELAY),
                          tap(errorObj => {
                            file = classRef.uploadUtil.autoRetryReqConditions(errorObj,file)
                          })
                      )
                  )
              )
              .subscribe(
                (event: HttpEvent<any>) => {
                  switch (event.type) {
                      case HttpEventType.Response:{
                        
                        classRef.initiateUploadpResponseHandler(event, file, fileMetadata,resolve,ffile,queueIndex,isFolderFile,uploadQueue)
                        break;
                      }
                  }
                },
                (err: HttpErrorResponse)=> {
                  let item = file;
                  if(isFolderFile)
                    item = ffile
                    item = classRef.uploadUtil.handleHttpError(err,item,resolve)
                }
              )
            }else{
              ffile.subscriptions.add(initiateUploadHttpRequest.pipe(
                retryWhen(errors =>
                      errors.pipe(
                          delay(UPLOAD_CONS.AUTORETRY_REQ_TIME_DELAY),
                          tap(errorObj => {
                            file = classRef.uploadUtil.autoRetryReqConditions(errorObj,file)
                          })
                      )
                  )
                ).subscribe( (event: HttpEvent<any>) => {
                    switch (event.type) {
                      case HttpEventType.Response:{
                        classRef.initiateUploadpResponseHandler(event, file,fileMetadata,resolve,ffile,queueIndex,isFolderFile,uploadQueue)
                        break;
                      }
                    }
              },
              (error: HttpErrorResponse)=> {
                classRef.uploadUtil.handleHttpError(error,ffile,resolve);
              }
              ));
            }
          })
          return classRef.uploadUtil.uploadedObjectResponse;
        }
      }
      catch (error) {
        classRef.universalService.showToast(error, "error");
        file.isError = true;
        file.uploadStarted = false;
        file.preparingUpload = false;
      }
    }
    
   
    public initiateUploadpResponseHandler(event, file, fileMetadata,resolve,ffile,queueIndex,isFolderFile,uploadQueue){
     
      let classRef = this;
      let responseStatus = event.status;
      file.retryCount = 0;         
      if(responseStatus == 200){
          let response = event.body;
          file.offset = response.offset;
          file.transactionId = response.transactionId;
          file.uploadedBytes = file.offset;
          classRef.startChunkUpload(file,response.offset,fileMetadata, true, null, UPLOAD_CONS.FIRST_CHUNK_SIZE,response.transactionId,resolve,ffile,queueIndex,isFolderFile,uploadQueue);
      }
      else if(responseStatus == 201){
        if(!isFolderFile){
          file.isError = false;
          file.hideProgress = true;
          file.uploadStarted = false;
          file.preparingUpload = false;
          file.uploadDone = true;
          
        }
        if(isFolderFile)
          classRef.updateUploadedfolderSize(ffile,event.body.sizeInBytes)
        else{
          file.objectKey = event.body.objectKey;
          file.imageTranscodeUrl = classRef.uploadUtil.populateThumbnailUrlPostUpload(event.body?.imageTranscodeUrl,event.body?.mimeType,event.body?.mimeSubType,file?.locationOfUpload)
          if(file["boardKey"]){
            file["objectMetadata"] = event.body
          }
          classRef.uploadUtil.emitUploadedObject(event.body);
        }
        classRef.uploadUtil.setUploadResponseOfCurrentlyUploadedFileInObject("success",event.body);
        resolve()
      }
    }

  
    public chunkUploadProgress(file,ffile,queueIndex,isFolderFile){
      if(isFolderFile){
        let progress = this.uploadUtil.folderUploadProgress("", ffile);
        ffile.progress = progress["progress"];
        if (ffile.circle != undefined) {
          ffile.circle.set(progress["progress_perc"]);
        }
      }else{
        var uploadedBytes = file.uploadedBytes;
        file.progress = Math.round(uploadedBytes * 100 / file.size);
        if(file.circle){
          file.circle.set(file.progress);
        } 
      }
    }  
    
    public async startChunkUpload(file,currentOffset, fileMetadata, isStart, chunkUploadTime, chunkSizeTej, transactionId,resolve,ffile,queueIndex,isFolderFile,uploadQueue){
      let classRef = this; 
      if (!isStart) { // after first chunk upload, calculating next chunk size wrt prv chunk upload time & rate
        chunkSizeTej = classRef.getChunkSize(chunkUploadTime, chunkSizeTej, file.size, currentOffset);
      }
      file.uploadStarted = true;
      let chunkUploadStartTime = new Date().getTime()
      let blobSlice = File.prototype.slice;
      
      var chunk = blobSlice.call(file, currentOffset, currentOffset+ chunkSizeTej)
      try{ 
        let chunkChecksum = await classRef.uploadUtil.getIncrementalChecksumUtilInstance(UploadLargeFile.uploadLargeFileRef).getFileHash(chunk,queueIndex,uploadQueue);
        let headers = new HttpHeaders();
        headers = headers.append('X-Offset', currentOffset + '');
        headers =  headers.append('Content-MD5', chunkChecksum + '');
        headers =  headers.append('Content-Type', 'application/octet-stream');
        headers =  headers.append('processData', 'false');
        const httpOptions = { observe: 'events', reportProgress: true, headers: headers}
        let url = '';
        if(window.location.href.includes("sharedwithme")){
          url = SHARE_DC["DC_URLS"]["CHUNK_UPLOAD"]+transactionId;
        }else{
          url = UPLOAD_CONS.SERVICE_URL.CHUNK_UPLOAD +transactionId;
        }
        if(file["tfKey"]){
          url = url + "&tfKey=" + file["tfKey"];
        }
        let chunkUploadHttpRequest = classRef.http.put(url, chunk, httpOptions)
        if(!isFolderFile){
          file.subscriber = chunkUploadHttpRequest.pipe(
            retryWhen(errors => // Auto Retry Request  or Error Out, for conditions check 'ifRetryRequest' function
                errors.pipe(
                  delay(UPLOAD_CONS.AUTORETRY_REQ_TIME_DELAY),
                  tap(errorObj => {
                    file = classRef.uploadUtil.autoRetryReqConditions(errorObj,file);
                  })
                )
              )
            ).subscribe(
                (event: HttpEvent<any>) => {
                    switch(event.type){
                        case HttpEventType.UploadProgress: {
                          classRef.getchunkUploadProgress(event,file, ffile, chunkSizeTej + currentOffset,queueIndex,transactionId,currentOffset,isFolderFile,uploadQueue);
                          break;
                        }
                        case HttpEventType.Response: {
                          let chunkUploadEndTime = new Date().getTime()
                          let chunkUploadTime = chunkUploadEndTime - chunkUploadStartTime;
                          if(isFolderFile)
                            classRef.updateUploadedfolderSize(ffile,chunk)
                          classRef.chunkUploadResponseHandler(event, chunkUploadTime, chunkSizeTej,fileMetadata,file,resolve,ffile,queueIndex,isFolderFile,uploadQueue);
                        }
                    }  
                },
                (err: HttpErrorResponse)=> {
                  classRef.uploadUtil.handleHttpError(err.error,file,resolve)
                } 
            )
        }else{
          ffile.subscriptions.add(chunkUploadHttpRequest.pipe(
            retryWhen(errors =>
                  errors.pipe(
                      delay(UPLOAD_CONS.AUTORETRY_REQ_TIME_DELAY),
                      tap(errorObj => {
                        file = classRef.uploadUtil.autoRetryReqConditions(errorObj,file)
                      })
                  )
              )
            ).subscribe( 
              (event: HttpEvent<any>) => {
                switch (event.type) {
                  case HttpEventType.UploadProgress: {
                    classRef.getchunkUploadProgress(event,file, ffile, chunkSizeTej + currentOffset,queueIndex,transactionId,currentOffset,isFolderFile,uploadQueue);
                    break;
                  }
                  case HttpEventType.Response: {
                    let chunkUploadEndTime = new Date().getTime()
                    let chunkUploadTime = chunkUploadEndTime - chunkUploadStartTime;
                    if(isFolderFile)
                      classRef.updateUploadedfolderSize(ffile,chunkSizeTej)
                    classRef.chunkUploadResponseHandler(event, chunkUploadTime, chunkSizeTej,fileMetadata,file,resolve,ffile,queueIndex,isFolderFile,uploadQueue);
                  }
                }
              },
              (err: HttpErrorResponse)=> {
                classRef.uploadUtil.handleHttpError(err.error,ffile,resolve);
              }
          ));
        }
      }
      catch(error){
        classRef.universalService.showToast(error, "error");
        file.isError = true;
        file.preparingUpload = false;
        file.uploadStarted = false;
        resolve()
      }
    }
  
    public chunkUploadResponseHandler(event, chunkUploadTime, chunkSizeTej, fileMetadata, file,resolve,ffile,queueIndex,isFolderFile,uploadQueue) {
      let classRef = this;
      file.retryCount = 0;
      if (event.status == 200 && event.body) {
        let response = event.body;
        if (response.offset && response.offset < (file.size - 1)) {
          file.uploadedBytes = response.offset;
          file.offset = file.uploadedBytes;
          file.alreadyExists = false;
          classRef.startChunkUpload(file,response.offset, fileMetadata, false, chunkUploadTime, chunkSizeTej, response.transactionId,resolve,ffile,queueIndex,isFolderFile,uploadQueue);
        }
      }
      else if (event.status == 201 && event.body) {
        file.uploadedBytes = file.size;
        file.remainingLargeSizeRead = 0;
        file.alreadyExists = false; // need to check this
        file.isError = false;
        file.hideProgress = true;
        file.uploadStarted = false;
        file.preparingUpload = false;
        file.uploadDone = true;
        classRef.chunkUploadProgress(file,ffile,queueIndex,isFolderFile)
        if(!isFolderFile){
          file.objectKey = event.body.objectKey;
          file.imageTranscodeUrl = classRef.uploadUtil.populateThumbnailUrlPostUpload(event.body?.imageTranscodeUrl,event.body?.mimeType,event.body?.mimeSubType,file?.locationOfUpload)
          if(file["boardKey"]){
            file["objectMetadata"] = event.body
          }
          classRef.uploadUtil.emitUploadedObject(event.body);
        }
        classRef.uploadUtil.setUploadResponseOfCurrentlyUploadedFileInObject("success",event.body);
        resolve();
      }
    }

    public getChunkSize(chunkUploadTime, currentChunkSize, fileSize, currentOffset) {
      // Note: calculating estimatedChunkSizeInDefinedTime in kb/s
      chunkUploadTime = chunkUploadTime/1000; // converting ms to seconds
      var sizeUploadedInKB = currentChunkSize/1024; // converting chunk size from bytes to KB
      currentChunkSize = currentChunkSize / (1024 * 1024); // converting bytes to MB
      var maxChunkSizeInMB = UPLOAD_CONS.MAX_CHUNK_SIZE_IN_MB;
      var minChunkSizeInMB = UPLOAD_CONS.MIN_CHUNK_SIZE_IN_MB;
  
      var estimatedChunkSizeInDefinedTime = ((sizeUploadedInKB*30)/chunkUploadTime); // formula : (size uploaded * 30 / time taken to upload the chunk)
      var nextChunk = (currentChunkSize * 2 > maxChunkSizeInMB ? maxChunkSizeInMB : currentChunkSize * 2);
      var previousChunk = currentChunkSize == maxChunkSizeInMB ? 16 : ((currentChunkSize / 2) <= minChunkSizeInMB ? minChunkSizeInMB : currentChunkSize / 2);
  
      if((estimatedChunkSizeInDefinedTime / 1024) > currentChunkSize && (estimatedChunkSizeInDefinedTime / 1024) >= nextChunk){
          currentChunkSize = nextChunk
      }else if((estimatedChunkSizeInDefinedTime / 1024) < currentChunkSize){
          currentChunkSize = previousChunk
      }else{
        console.log("no change in chunk size, using the existing chunk size",currentChunkSize)
      }
      console.log("chunk size ==>>",currentChunkSize);
      return currentChunkSize * 1024 * 1024;
    }
   
    private updateUploadedfolderSize(ffile, sizeInBytes){ 
      ffile.uploadedFolderSize = ffile.uploadedFolderSize + sizeInBytes;
    }
  

    timeRemaining:any =0;
    public async getchunkUploadProgress(evt, fileObj, ffile, nextOffset, queueIndex, transactionId, currentOffset, isFolderFile, uploadQueue) {
      let classRef = this;
      uploadQueue[queueIndex].remainingLargeSizeUpload = uploadQueue[queueIndex].largeSize - nextOffset;
      let timeDiffCheck = await classRef.getBytesUploadedArray(evt, fileObj, ffile, nextOffset, queueIndex, transactionId, currentOffset,isFolderFile, uploadQueue);
      if (timeDiffCheck && uploadQueue[queueIndex].uploadLargeByteMap.get(fileObj.hash) != undefined && uploadQueue[queueIndex].uploadLargeByteMap.get(fileObj.hash).length > 1) {  //this.uploadQueue[queueIndex].uploadLargeByteTimeArray
        await classRef.getUploadRate(fileObj, ffile, queueIndex, transactionId, isFolderFile, uploadQueue)
        if (classRef.uploadUtil.isSingleUploadOn(uploadQueue) || UploadQueueImpl.timeLeftToFinishUpload == "" ) {
          if (UploadQueueImpl.commonLargeFileUploadRate > 0) {
            this.totalRemainingBytes = this.uploadUtil.getTotalRemainingBytes(uploadQueue);
            let totalRemainingBytes = this.totalRemainingBytes;
            this.timeRemaining = totalRemainingBytes / (UploadQueueImpl.commonLargeFileUploadRate * 1000);// time in sec
  
            let leftReadingtime = 0;
            let totalRemainingReadingBytes = this.uploadUtil.getRemainingLargeFileSizeRead(uploadQueue);
  
            if (totalRemainingReadingBytes > 0 && UploadQueueImpl.commonReadRate > 0) {
              leftReadingtime = totalRemainingReadingBytes / (UploadQueueImpl.commonReadRate * 1000); // in sec
              this.timeRemaining = this.timeRemaining + leftReadingtime;
            }
            this.getEstimatedUploadTimeString(UploadQueueImpl.commonLargeFileUploadRate, ffile, true,uploadQueue,this.totalRemainingBytes);//getEstimatedUploadTimeString_Folder
          }
  
        }
        else {
          this.getMultipleUploadTotalTime(UploadQueueImpl.commonLargeFileUploadRate, false, fileObj,uploadQueue) 
        }
      } else {
        if (UploadQueueImpl.timeLeftToFinishUpload.length == 0){
          UploadQueueImpl.timeLeftToFinishUpload = 'Started Uploading..'
        }
      };
    }

    public getBytesUploadedArray(evt, fileObj, ffile, nextOffset,queueIndex,transactionId,currentOffset,isFolderFile, uploadQueue){
      let classRef= this;
      let tempArray = [];
      let currentTime = new Date().getTime();
      if(uploadQueue[queueIndex].uploadLargeByteMap.get(fileObj.hash)!=undefined)
        tempArray = uploadQueue[queueIndex].uploadLargeByteMap.get(fileObj.hash);
      
        let arrayLength = tempArray.length;
        if(arrayLength> 0 && tempArray[arrayLength-1] && 
          (currentTime - tempArray[arrayLength-1].time < UPLOAD_CONS.ESTIMATED_LGF_TIME_CALC_DELAY)) {
          return false;
        }
        else{
          tempArray.push({
            'bytes': (currentOffset+evt.loaded), //allready uploaded chunks size + bytes uploaded of the current chunk
            'time': currentTime,
            'remainingBytes' :classRef.totalRemainingBytes - evt.loaded,
            'nextOffset': nextOffset
          });
          uploadQueue[queueIndex].uploadLargeByteMap.set(fileObj.hash,tempArray)
         
        }
        if(isFolderFile){
          let progress = classRef.uploadUtil.folderUploadProgress("", ffile);
          ffile.progress = progress["progress"];
          if (ffile.circle != undefined) {
            ffile.circle.set(progress["progress_perc"]);
          }
        }else{
          fileObj.progress = Math.round((fileObj.offset + evt.loaded) * 100 / fileObj.size);
          fileObj.circle.set((fileObj.offset + evt.loaded)/fileObj.size)
        }
        return true;
    }

  public getUploadRate(fileObj, ffile, queueIndex, transactionId, isFolderFile, uploadQueue) {
    let tempArray = uploadQueue[queueIndex].uploadLargeByteMap.get(fileObj.hash);//
    const arrayLength = tempArray.length;

    if (arrayLength > 1) {
      let uploadRate = (tempArray[arrayLength - 1]['bytes'] - tempArray[arrayLength - 2]['bytes']) /
        (tempArray[arrayLength - 1]['time'] - tempArray[arrayLength - 2]['time']);
         if (uploadRate < 99) { /* change to 99 for upper env */
          return;
        }
      let totalUploadRate = 0;

      let largeUploadRateArrayLength = this.largeUploadRateArray.length;
      let avgLoadRate = uploadRate;
      let smallLoadRate = 0;
      let largeLoadRate = 0;
      if (largeUploadRateArrayLength > 2) {
        if (this.largeUploadRateArray[0] > this.largeUploadRateArray[1]) {
          smallLoadRate = this.largeUploadRateArray[1];
          largeLoadRate = this.largeUploadRateArray[0];
        } else {
          smallLoadRate = this.largeUploadRateArray[0];
          largeLoadRate = this.largeUploadRateArray[1];
        }
        for (let pos = 2; pos < largeUploadRateArrayLength; pos++) {
          if (this.largeUploadRateArray[pos] <= smallLoadRate) {
            smallLoadRate = this.largeUploadRateArray[pos];
          } else if (this.largeUploadRateArray[pos] >= largeLoadRate) {
            largeLoadRate = this.largeUploadRateArray[pos];
          }
        }

        if (uploadRate < smallLoadRate || uploadRate > (largeLoadRate * 2))
          return;
        else
          avgLoadRate = (smallLoadRate + largeLoadRate) / 2;

      } else if (largeUploadRateArrayLength > 0) {
        this.largeUploadRateArray.forEach(obj => {
          totalUploadRate = totalUploadRate + obj;
        });
        avgLoadRate = totalUploadRate / largeUploadRateArrayLength;
      }
      if (avgLoadRate < 99 && smallLoadRate > 0 && largeLoadRate > 0)
        return;
      this.largeUploadRateArray.push(uploadRate)
      ffile.lastUploadRate = uploadRate;
      UploadQueueImpl.commonLargeFileUploadRate = uploadRate;
      if (this.largeUploadRateArray.length > 5) {
        this.largeUploadRateArray.shift();
      }
    }
  }

  public getEstimatedReadTimeString(rate) {
    if ((this.timeRemaining > 0 && this.timeRemaining <= 3) || !rate) {
      UploadQueueImpl.timeLeftToFinishUpload = `Started Uploading..`
      return;
    }
    else if ((rate == 0 || rate < 0) || (this.timeRemaining == "Infinity" || this.timeRemaining <= 0)) {
      return;
    }
    else if (this.timeRemaining < 60 && this.timeRemaining > 1 &&  UploadQueueImpl.timeLeftToFinishUpload == "") {
      UploadQueueImpl.timeLeftToFinishUpload = `Initializing upload in less than a min (${Math.round(this.timeRemaining)} seconds)`;
    }
    else if (this.timeRemaining > 60 &&  UploadQueueImpl.timeLeftToFinishUpload == "") {
      this.timeRemaining = Math.round(this.timeRemaining / 60 );
      UploadQueueImpl.timeLeftToFinishUpload = `Initializing upload  in ${this.timeRemaining} min`;
    }
  }
    
  public getMultipleUploadTotalTime(rate, isReading, file,uploadQueue) { 
    let readingSize = this.uploadUtil.getRemainingLargeFileSizeRead(uploadQueue);
    if(isReading && (UploadQueueImpl.commonSmallFileUploadRate + UploadQueueImpl.commonLargeFileUploadRate)<=0){
      let readingTime = readingSize / rate // pending time remaing for comple
      this.timeRemaining = readingTime/1000;
      this.getEstimatedReadTimeString(rate)
    }else{
      let classRef = this;
      let pendingUploadSmallBytes = this.uploadUtil.getRemainingSmallFileSizeUpload(uploadQueue);
      let pendingUploadLargeBytes = this.uploadUtil.getRemainingLargeFileSizeUpload(uploadQueue);
      let avgLoadRate = (UploadQueueImpl.commonSmallFileUploadRate + UploadQueueImpl.commonLargeFileUploadRate)/2;
      let pendingtime = 0;
      if(UploadQueueImpl.commonReadRate > 0 && readingSize>0 )
        pendingtime = readingSize/(UploadQueueImpl.commonReadRate*1000) 
      if(UploadQueueImpl.commonLargeFileUploadRate>0 && pendingUploadLargeBytes>0)
        pendingtime =  pendingtime + pendingUploadLargeBytes/(UploadQueueImpl.commonLargeFileUploadRate*1000);
      if(UploadQueueImpl.commonSmallFileUploadRate>0 && pendingUploadSmallBytes>0)
        pendingtime =  pendingtime + pendingUploadSmallBytes/(UploadQueueImpl.commonSmallFileUploadRate*1000);
      this.timeRemaining = pendingtime;
      if (classRef.timeRemaining == "Infinity" || classRef.timeRemaining <= 0) {
        return;
      }
      let remain = pendingUploadSmallBytes+pendingUploadLargeBytes
      this.getEstimatedUploadTimeString(avgLoadRate, file, false,uploadQueue,remain); // getting estimated Upload time Message;
    }
  }

  public getEstimatedUploadTimeString(rate, file, isSingleFileUpload: boolean,uploadQueue,remainingdata) {
    if ((rate == 0 || rate < 0) || (this.timeRemaining == "Infinity" || this.timeRemaining <= 0)) {
      UploadQueueImpl.timeLeftToFinishUpload = `Started Uploading..`
        return;
    }
    if ( this.uploadUtil.isLastFileToUpload(uploadQueue).length == 1 && ( this.timeRemaining<5 || remainingdata< 2000 || this.uploadUtil.isLastFileToUpload(uploadQueue)[0].progress > 80)) {//else if  ((this.timeRemaining <= 10 || file.progress > 95) && this.uploadUtil.isLastFileToUpload()) { 
      UploadQueueImpl.timeLeftToFinishUpload = `Finishing upload..`
    }else if (this.timeRemaining >= 5 && this.timeRemaining < 60) {
      UploadQueueImpl.timeLeftToFinishUpload = "Less than a minute left (" + Math.round(this.timeRemaining) + " seconds)";
    }
    else if (this.timeRemaining >= 60) {
      let timeRemainingInMin = this.timeRemaining/60;
      if(timeRemainingInMin>60){
        let hour = timeRemainingInMin/60;
        let min = timeRemainingInMin%60;
        UploadQueueImpl.timeLeftToFinishUpload = `${Math.round(hour)} hour & ${Math.round(min)} min left..`;
      }else{
        UploadQueueImpl.timeLeftToFinishUpload = `${Math.round(timeRemainingInMin)} min left..`;
      }
    }
  }


  

}